import { SolarResponse, SupernovaResponse } from '../../foundation'
import { asBuilder } from '../asBuilder'

export const getSupernovaResponse = asBuilder((): SupernovaResponse<unknown> => {
  return {
    timestamp: '2023-06-28T23:35:07.062744',
    status: 200,
    message: 'Success',
    body: null,
  }
})

export const getSolarResponse = asBuilder((): SolarResponse<unknown> => {
  return {
    reason: 'Invalid',
    msgCode: null,
    succeeded: true,
    data: null,
  }
})
